import { Map } from 'immutable';

import * as t from '../../actions/dashboardActionType';

const initialState = Map({
  loadingInviteAFriend: false,
  response: [],
});

const reducer = function inviteAFriendReducer(state = initialState, action) {
  switch (action.type) {
    case t.SET_INVITE_A_FRIEND:
      return state.set('response', action.response);

    case t.SET_IS_LOADING_INVITE_A_FRIEND:
      return state.set('loadingInviteAFriend', action.isLoadingInviteAFriend);

    default:
      return state;
  }
};

export default reducer;
